class FacetFiltersForm extends HTMLElement{
  constructor(){
    super();
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
      document.querySelector('body').classList.remove('open-filter');
    }, 500);
    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
  }
  static setListeners(){
      const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }
  static renderPage(searchParams, event, updateURLHash = true){
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
      FacetFiltersForm.renderSectionFromFetch(url, event);
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }
  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
      });
    }
    static renderSectionFromCache(filterDataUrl, event){
      const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
    }
    static renderProductGridContainer(html){
      document.getElementById('collection-grid').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('collection-grid').innerHTML;
    }
      static renderFilters(html, event){
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      const facetDetailsElements =
        parsedHTML.querySelectorAll('.filter-index');
      const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.filter-index') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
          const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    facetsToRender.forEach((element) => {
      document.querySelector(`.filter-index[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });
  }
  static updateURLHash(searchParams){
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }
  static getSections(){
    return [{
      section: document.getElementById('collection-grid').dataset.id,
    }]
  }
  onSubmitHandler(event){    
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);    
  }
}
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
function rangePrice(params) {
  var lowerSlider = document.querySelector('#lower'),
   upperSlider = document.querySelector('#upper'),
   lowerVal = parseInt(lowerSlider.value);
   upperVal = parseInt(upperSlider.value);
  upperSlider.oninput = function() {
    lowerVal = parseInt(lowerSlider.value);
    upperVal = parseInt(upperSlider.value);    
    $('.nextsetval').val(upperVal);
    $('.prevtsetval').val(lowerVal);
    if (upperVal < lowerVal + 4) {
      lowerSlider.value = upperVal - 4;
      if(lowerVal == lowerSlider.min)
         upperSlider.value = 4;
    }
    let rr_slider = $('.price-right');
    let rr_val = rr_slider.val();
    let rr_width = rr_slider.width() - 15;
    let rr_min = rr_slider.attr('min');
    let rr_max = rr_slider.attr('max');
    let rr_percent = (rr_val - rr_min) / (rr_max - rr_min);
    let rr_offset = -3;
    let rr_newPosition = rr_width * rr_percent + rr_offset;
  };
  lowerSlider.oninput = function() {
    lowerVal = parseInt(lowerSlider.value);
    upperVal = parseInt(upperSlider.value);
    $('.prevtsetval').val(lowerVal);
    $('.nextsetval').val(upperVal);
    if (lowerVal > upperVal - 4) {
      upperSlider.value = lowerVal + 4;
      if (upperVal == upperSlider.max) {
         lowerSlider.value = parseInt(upperSlider.max) - 4;
      }
    }
    let rl_slider = $('.price-left');
    let rl_val = rl_slider.val();
    let rl_width = rl_slider.width() - 15;
    let rl_min = rl_slider.attr('min');
    let rl_max = rl_slider.attr('max');
    let rl_percent = (rl_val - rl_min) / (rl_max - rl_min);
    let rl_offset = -3;
    let rl_newPosition = rl_width * rl_percent + rl_offset;
  }; 
  $('.prevtsetval').on('change, keyup',function (e) {
    $('.price-left').val($(this).val());
    rangePrice();
  });
  $('.nextsetval').on('change, keyup',function (e) {
    $('.price-right').val($(this).val());
    rangePrice();
  });
}
if (document.querySelector(".rangecls")) {
  rangePrice();
}
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
$(document).on('click','.coll-filter h4',function(){
  $(this).next('.coll-filter-wrap').slideToggle();
  $(this).parent('.coll-filter').toggleClass('active');
});
$(document).on('click','.mob_filterbtn',function (e) {
  e.preventDefault();
  $('body').toggleClass('filter-open');
  $('#form-facet .coll-filter').each(function(){
    if(!$(this).hasClass('active')){
      $(this).addClass('active');
      $(this).next('.coll-filter-wrap').slideDown();    
    }
  });
});
$(document).on('click','.filter-close,.overlay-box',function (e) {
  e.preventDefault();
  $('body').removeClass('filter-open');
});